import axios from "axios";

export function shopEdit(businessData, type) {
  let id = businessData.businessId;
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${id}`,
    data: {
        businessData
    }
  };
  return axios(config);
}

export function updateRichmenu(accountId) {
  let configBusiness = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts/${accountId}/richmenu`,
    data: data
  };
  return axios(configBusiness);
}

export function assignToSpecificSiAccount(data) {
  let configBusiness = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${data.shopId}/si-account`,
    data: data
  };
  return axios(configBusiness);
}

export function shopStatus(businessData, type) {
  let accountId = businessData.accountId;
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${accountId}/status`,
    data: {
        isEnabled: businessData.isEnabled
    }
  };
  return axios(config);
}